import source from "@/messages/quiz-progress-source.json";
import mandarinQuizProgressDraft from "@/messages/mandarin-quiz-progress.json";
import type { Locale } from "./locales";

export type QuizProgressCopy = typeof source;
export function quizProgressCopy(locale: Locale = "en"): QuizProgressCopy {
  // These catalogues contain only strings; a shallow copy isolates callers on older browsers.
  return { ...(locale === "en" ? source : mandarinQuizProgressDraft) };
}
export function formatQuizProgress(
  value: string,
  values: Record<string, number>
): string {
  return value.replace(/\{([^}]+)\}/g, (_, key: string) => {
    if (!(key in values))
      throw new Error(`Missing quiz progress value: ${key}`);
    return String(values[key]);
  });
}
